var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4182_4802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 14.6654L13.332 13.332M7.66536 13.9987C8.49707 13.9987 9.32063 13.8349 10.089 13.5166C10.8574 13.1983 11.5556 12.7318 12.1437 12.1437C12.7318 11.5556 13.1983 10.8574 13.5166 10.089C13.8349 9.32063 13.9987 8.49707 13.9987 7.66536C13.9987 6.83366 13.8349 6.0101 13.5166 5.2417C13.1983 4.47331 12.7318 3.77513 12.1437 3.18702C11.5556 2.59892 10.8574 2.13241 10.089 1.81413C9.32063 1.49585 8.49707 1.33203 7.66536 1.33203C5.98566 1.33203 4.37475 1.99929 3.18702 3.18702C1.99929 4.37475 1.33203 5.98566 1.33203 7.66536C1.33203 9.34507 1.99929 10.956 3.18702 12.1437C4.37475 13.3314 5.98566 13.9987 7.66536 13.9987Z",
    stroke: "#1390E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4182_4802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0fb092a39957855a8c04068df462a0ef.svg";
export { ForwardRef as ReactComponent };